import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";

export default {
  computed: {
    votingLimitRules() {
      return this.$store.state.votingLimitRules.votingLimitRules;
    },
    meetingDetails() {
      return this.$store.state.meetingDetails.meetingDetails;
    },

    isInMeetingUpsert() {
      return this.$route.name == "create-meeting" || this.$route.name == "edit-meeting";
    },
    allCountries() {
      return this.$store.getters.getCountries;
    },
  },
  methods: {
    saveMeetingInDb(meetingId, meeting = undefined) {
      return new Promise((resolve, reject) => {
        if (!meeting) meeting = MeetingORM.getters("getById")(meetingId);
        MeetingMW.PUT(meeting, false)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    updateMeetingMinutesInDb(meetingId, meetingMinutes = undefined) {
      return new Promise((resolve, reject) => {
        if (!meetingMinutes) {
          let meeting = MeetingORM.getters("getById")(meetingId);
          meetingMinutes = meeting.minutes;
        }
        MeetingMW.UPDATE_MINUTES(
          {
            id: meetingId,
            minutes: meetingMinutes,
          },
          false
        )
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    getPerson(personInfo = {}) {
      try {
        const { personId } = personInfo;
        if (!personId) return {};

        // default options
        const personType = "personType" in personInfo ? personInfo.personType : "owner";

        var person = null;
        if (personType == "owner") {
          person = this.findBuildingOwnerData(personId);
        } else if (personType == "contact") {
          person = this.findContactData(personId);
        }

        return person;
      } catch (err) {
        console.error(err);
        return {};
      }
    },
    getPersonGender(personInfo, person = undefined) {
      try {
        if (!person) person = this.getPerson(personInfo);

        if (person.entity_type == this.entityTypes.legal) return "";

        const genderOption = this.genderOptions.find(opt => opt.value == person.gender);
        return genderOption ? genderOption.text : "";
      } catch {
        return "";
      }
    },
    getPersonName(personInfo, person = undefined) {
      try {
        if (!person) person = this.getPerson(personInfo);

        var name = "";
        if (person.lastname && person.firstname) {
          name = person.lastname + " " + person.firstname;
        } else if (person.lastname) {
          name = person.lastname;
        } else if (person.firstname) {
          name = person.firstname;
        }

        return name.toUpperCase();
      } catch (err) {
        console.error(err);
        return "";
      }
    },
    getPersonNameAndGender(personInfo, person = undefined) {
      try {
        const personGender = this.getPersonGender(personInfo, person);
        const personName = this.getPersonName(personInfo, person);

        var nameAndGender = "";
        if (personGender && personName) {
          nameAndGender = personGender + " " + personName;
        } else if (personName) {
          nameAndGender = personName;
        }

        return nameAndGender;
      } catch (err) {
        console.error(err);
        return "";
      }
    },
    getPersonAddress(personInfo, person = undefined) {
      try {
        if (!person) person = this.getPerson(personInfo);

        return person.address ? person.address : "";
      } catch (err) {
        console.error(err);
        return "";
      }
    },
    getPersonComplements(personInfo, person = undefined, complementNr = 1) {
      console.log(personInfo, person, complementNr);
      try {
        if (!person) person = this.getPerson(personInfo);

        if (complementNr == 2) {
          return person.complement2;
        } else {
          return person.complement;
        }
      } catch (err) {
        console.error(err);
        return "";
      }
    },
    getPersonZipcodeAndCity(personInfo, person = undefined) {
      try {
        if (!person) person = this.getPerson(personInfo);

        var zipcodeAndCity = "";
        if (person.zipcode && person.city) {
          zipcodeAndCity = person.zipcode + " " + person.city.toUpperCase();
        } else if (person.zipcode) {
          zipcodeAndCity = person.zipcode;
        } else if (person.city) {
          zipcodeAndCity = person.city.toUpperCase();
        }

        return zipcodeAndCity;
      } catch (err) {
        console.error(err);
        return "";
      }
    },

    getPersonCountry(personInfo, person = undefined) {
      try {
        if (!person) person = this.getPerson(personInfo);
        const personCountry = person.country ? person.country : "";
        const foundCountry = this.allCountries.find(item => {
          return item.countryCode == personCountry;
        });

        if (foundCountry == "-1" || foundCountry.countryName == "France") {
          return "";
        } else {
          return foundCountry.countryName;
        }
      } catch (err) {
        console.error(err);
        return "";
      }
    },

    getMandatesTantiemesChargeGenerale(
      mandates,
      applyVotingIncludesMandateRule = false,
      tantiemesType = "used"
    ) {
      var total = 0;
      mandates.forEach(mandate => {
        var addThisToo = true;
        if (
          applyVotingIncludesMandateRule &&
          !this.votingLimitRules.votingIncludesMandate &&
          mandate.building_owner_id == mandate.representant_owner_id
        ) {
          addThisToo = false;
        }
        if (addThisToo) {
          if (tantiemesType == "used") {
            total += this.getUsedMandateTantiemesChargeGenerale(mandate.id);
          } else if (tantiemesType == "total") {
            total += this.getTotalMandateTantiemesChargeGenerale(mandate.id);
          } else if (tantiemesType == "reduced") {
            total += this.getReducedMandateTantiemesChargeGenerale(mandate.id);
          }
        }
      });
      return this.formatNumber(total);
    },
    getUsedMandateTantiemesChargeGenerale(mandateId) {
      var buildingOwnerData = this.findBuildingOwnerDataByMandateId(mandateId);
      if (buildingOwnerData) {
        if (buildingOwnerData.reducedMandateTantiemesChargeGenerale) {
          return buildingOwnerData.reducedMandateTantiemesChargeGenerale;
        } else {
          return buildingOwnerData.totalMandateTantiemesChargeGenerale;
        }
      }

      return 0;
    },
    getTotalMandateTantiemesChargeGenerale(mandateId) {
      var buildingOwnerData = this.findBuildingOwnerDataByMandateId(mandateId);
      if (buildingOwnerData) {
        return buildingOwnerData.totalMandateTantiemesChargeGenerale;
      }

      return 0;
    },
    getReducedMandateTantiemesChargeGenerale(mandateId) {
      var buildingOwnerData = this.findBuildingOwnerDataByMandateId(mandateId);
      if (buildingOwnerData) {
        if (buildingOwnerData.reducedMandateTantiemesChargeGenerale) {
          return buildingOwnerData.reducedMandateTantiemesChargeGenerale;
        }
      }

      return 0;
    },

    getUsedVotesTantiemesByVotingCategory(votes, votingCategoryId) {
      var total = 0;
      votes.forEach(vote => {
        total += this.getUsedMandateTantiemesByVotingCategory(vote.mandate.id, votingCategoryId);
      });
      return this.formatNumber(total);
    },
    getUsedMandatesTantiemesByVotingCategory(mandates, votingCategoryId) {
      var total = 0;
      mandates.forEach(mandate => {
        total += this.getUsedMandateTantiemesByVotingCategory(mandate.id, votingCategoryId);
      });
      return this.formatNumber(total);
    },
    getUsedMandateTantiemesByVotingCategory(mandateId, votingCategoryId) {
      const buildingOwnerData = this.findBuildingOwnerDataByMandateId(mandateId);
      if (
        buildingOwnerData &&
        Object.keys(buildingOwnerData).length !== 0 &&
        buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]
      ) {
        if (
          buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]
            .reducedMandateTantiemesChargeGenerale
        ) {
          return buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]
            .reducedMandateTantiemesChargeGenerale;
        } else {
          return buildingOwnerData.votingRightsByVotingCategory[votingCategoryId].tantiemes;
        }
      }

      return 0;
    },

    getTotalTantiemesByVotingCategory(votingCategoryId) {
      var total = 0;
      this.meetingDetails.BuildingOwnersData.forEach(boData => {
        total += this.getTotalBOTantiemesByVotingCategory(boData.id, votingCategoryId);
      });

      return this.formatNumber(total);
    },
    getTotalBOTantiemesByVotingCategory(buildingOwnerId, votingCategoryId) {
      var buildingOwnerData = this.findBuildingOwnerData(buildingOwnerId);
      if (buildingOwnerData && buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]) {
        return buildingOwnerData.votingRightsByVotingCategory[votingCategoryId].tantiemes;
      }

      return 0;
    },
    getTotalBOTantiemesByVotingCategoryAndBuildingLot(
      buildingOwnerId,
      votingCategoryId,
      buildingLotId
    ) {
      var buildingOwnerData = this.findBuildingOwnerData(buildingOwnerId);
      if (
        buildingOwnerData &&
        buildingOwnerData.votingRightsByVotingCategory[votingCategoryId] &&
        buildingOwnerData.votingRightsByVotingCategory[votingCategoryId].byBuildingLot[
          buildingLotId
        ]
      ) {
        return buildingOwnerData.votingRightsByVotingCategory[votingCategoryId].byBuildingLot[
          buildingLotId
        ].tantiemes;
      }

      return 0;
    },

    getUsedTantiemesByVotingCategory(votingCategoryId) {
      var total = 0;
      this.meetingDetails.BuildingOwnersData.forEach(boData => {
        total += this.getUsedBOTantiemesByVotingCategory(boData.id, votingCategoryId);
      });

      return this.formatNumber(total);
    },
    getUsedBOTantiemesByVotingCategory(buildingOwnerId, votingCategoryId) {
      var buildingOwnerData = this.findBuildingOwnerData(buildingOwnerId);
      if (buildingOwnerData && buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]) {
        if (
          buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]
            .reducedMandateTantiemesChargeGenerale
        ) {
          return buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]
            .reducedMandateTantiemesChargeGenerale;
        } else {
          return buildingOwnerData.votingRightsByVotingCategory[votingCategoryId].tantiemes;
        }
      }

      return 0;
    },

    findBuildingOwnerDataByMandateId(mandateId) {
      return this.meetingDetails.BuildingOwnersData.find(bo => bo.mandate_id == mandateId) || {};
    },
    findBuildingOwnerData(buildingOwnerId) {
      return this.meetingDetails.BuildingOwnersData.find(bo => bo.id == buildingOwnerId) || {};
    },
    findContactData(contactId) {
      return this.meetingDetails.ContactsData.find(contact => contact.id == contactId) || {};
    },
    findBuildingData(buildingId) {
      return this.meetingDetails.BuildingDataData.find(b => b.id == buildingId) || {};
    },
    findMajorityData(majorityId) {
      return this.meetingDetails.MajoritiesData.find(m => m.id == majorityId) || {};
    },
    findVotingCategoryData(votingCategoryId) {
      return this.meetingDetails.VotingCategoriesData.find(vc => vc.id == votingCategoryId) || {};
    },
    getAddressByMandate(mandateId) {
      var buildingOwnerData = this.findBuildingOwnerDataByMandateId(mandateId);
      return buildingOwnerData.address;
    },
    getUsedTantiemesChargeGeneral() {
      var total = 0;
      this.meetingDetails.BuildingOwnersData.forEach(boData => {
        total += boData.totalMandateTantiemesChargeGenerale;
      });

      return this.formatNumber(total);
    },
    getUsedMandatesTantiemesByChargeGeneral(mandates) {
      var total = 0;
      mandates.forEach(mandate => {
        total += this.getTotalMandateTantiemesChargeGenerale(mandate.id);
      });
      return this.formatNumber(total);
    },
    countUsedMandatesWithVoteRightByVotingCategory(mandates, votingCategoryId) {
      var counter = 0;
      mandates.forEach(mandate => {
        if (this.getUsedMandateTantiemesByVotingCategory(mandate.id, votingCategoryId) != 0) {
          counter += 1;
        }
      });
      return this.formatNumber(counter);
    },
  },
};
